import React from 'react'
import axios from 'axios';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react'


function ReviewSelection({ hashedId, LanguageSelected }) {
    const [ReviewModal, setReviewModal] = useState(false)
    const { i18n } = useTranslation();
    const { t } = useTranslation();
    const apiUrl = process.env.REACT_APP_BACKEND_URL;
    const ImageUrl = process.env.REACT_APP_IMAGES_URL
    const frontEndUrl = process.env.REACT_APP_REACT_URL

    const [ParametreContent, setParametreContent] = useState([])
    const [Done, setDone] = useState(false)
    const [InputsErrors, setInputsErrors] = useState([])

    const [paramsSelected, setParamsSelected] = useState({ id: null, name: null })
    const [isFetching, setisFetching] = useState(false)

    const [reviewParams, setReviewParams] = useState(false)

    const [reviewRating, setReviewRating] = useState([])

    const [ReviewExists, setReviewExists] = useState(true)

    const [clientInfo, setClientInfo] = useState({
        lastName: null, firstName: null, user_id: hashedId, ratings: [
        ]
    })

    const [singleRating, setSingleRating] = useState({ id: null, name: null, comment: null, rating: 0 })

    const [EntrepriseParametreData, setEntrepriseParametreData] = useState([])
    const [EntrepriseExists, setEntrepriseExists] = useState(false)


    const AddingReviewInfo = (e) => {
        return setClientInfo({ ...clientInfo, [e.target.name]: e.target.value })

    }

    // const handleConfirm = (id) => {
    //     setClientInfo(prevState => ({
    //         ...prevState,
    //         ratings: prevState.ratings.map(rating => {
    //             if (rating.id === id) {
    //                 return singleRating;
    //             }
    //             return rating;
    //         })
    //     }));
    // };

    const getRatingInfo = (name, id) => {
        const rating = clientInfo.ratings.find(item => item.id === id);
        return name === 'comment' ? rating?.comment || '' : rating?.rating || 0;
    };




    function handleChange(newId, value, type) {
        setClientInfo(prevState => ({
            ...prevState,
            ratings: prevState.ratings.map(rating => {
                if (rating.id === newId) {
                    if (type === 'comment') {
                        rating.comment = value;
                    } else {
                        rating.rating = value;
                    }
                }
                return rating;
            })
        }));
    }



    useEffect(() => {
        getParametres()
    }, [Done])


    const getParametres = () => {
        setClientInfo(prevState => ({ ...prevState, ratings: [] }))
        fetch(`${apiUrl}/getParametresreviewProfile`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ user_id: hashedId })
        })
            .then(response => response.json())
            .then(result => {
                if (result.success && !result.entreprise) {
                    setParametreContent(result.data)

                    result.data.forEach(item => {
                        setClientInfo(prevState => ({
                            ...prevState,
                            ratings: [...prevState.ratings, { id: item.id, name: item.name, comment: null, rating: 0 }]
                        }));
                    })


                }
                else if (result.success && result.entreprise) {
                    setEntrepriseParametreData(result.data)
                    setEntrepriseExists(true)

                    result.data.forEach(item => {
                        setClientInfo(prevState => ({
                            ...prevState,
                            ratings: [...prevState.ratings, { id: item.id, name: item.value, comment: null, rating: 0 }]
                        }));
                    })

                }
            })
    }

    const addReviewSelection = async (e) => {
        setisFetching(true);
        e.preventDefault()
        fetch(`${apiUrl}/addReviewSelection`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(clientInfo)
        })
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    setClientInfo({ lastName: null, firstName: null, user_id: hashedId, ratings: [] })
                    setDone(!Done)
                    setInputsErrors([])
                    setReviewModal(false)
                    toast.success(result.message, {
                        position: toast.POSITION.CENTER
                    });

                }
                else {
                    setInputsErrors(result.errors)
                }
            })
            .finally(() => {
                setisFetching(false);
            });
    };




    return (
        <div className='w-full'>
            {ParametreContent.length > 0 || EntrepriseParametreData.length > 0 &&
                <button onClick={() => setReviewModal(true)} className="btn-review grid place-items-center" href="#">
                    <p>{t('Leave a review')}</p>

                   
                </button>

            }

            {ReviewModal &&

                <div>

                    <div className="minscreen h-full animated  overflow-auto fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-1000 div-sections overflow">
                        <div className="absolute top-0 right-0 p-4">
                            <a className='w-12 h-12' onClick={() => { setReviewModal(false); setInputsErrors([]) }}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme  cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                                </svg>
                            </a>
                        </div>
                        <div className="w-full settingswidth h-full py-5 px-5 text-about rounded-md">
                            <h2 className="text-3xl text-theme mb-2">{t("Add your review")}</h2>
                            <h2 className="text-2xl text-about  mb-6">{t("Complétez les informations de votre review")}
                            </h2>
                            <form className="space-y-4">
                                <div className="flex gap-3 w-full">
                                    <div className="mt-2 w-full">
                                        <input onChange={(e) => AddingReviewInfo(e)} type="text" id="firstName" name="firstName" className="block placeholder-sm text-sm p-2.5 w-full text-sm h-14 sections rounded-md border-none " placeholder={t("Prenom")} required />
                                        <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('firstName') && InputsErrors.firstName}</span></p>

                                    </div>
                                    <div className="mt-2 w-full">
                                        <input onChange={(e) => AddingReviewInfo(e)} type="text" id="lastName" name="lastName" className="block placeholder-sm text-sm p-2.5 w-full text-sm h-14 sections rounded-md border-none " placeholder={t("Nom")} required />
                                        <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('lastName') && InputsErrors.lastName}</span></p>

                                    </div>
                                </div>   <div className="mt-2 w-full">
                                    <input onChange={(e) => AddingReviewInfo(e)} type="text" id="phone" name="phone" className="block placeholder-sm text-sm p-2.5 w-full text-sm h-14 sections rounded-md border-none " placeholder={t("Phone")} required />
                                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('phone') && InputsErrors.phone}</span></p>

                                </div>
                                <div className="mt-2 w-full">
                                    <input onChange={(e) => AddingReviewInfo(e)} type="email" id="email" name="email" className="block placeholder-sm text-sm p-2.5 w-full text-sm h-14 sections rounded-md border-none " placeholder={t("Email")} required />
                                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('email') && InputsErrors.email}</span></p>

                                </div>

                                <div className="">
                                    <input onChange={(e) => AddingReviewInfo(e)} type="text" id="entreprise" name="entreprise" className="block placeholder-sm text-sm p-2.5 w-full text-sm h-14 sections rounded-md border-none " placeholder={t("Entreprise")} required />
                                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('entreprise') && InputsErrors.entreprise}</span></p>

                                </div>
                                {
                                    EntrepriseExists ? (
                                        EntrepriseParametreData && EntrepriseParametreData.map((item, index) => (
                                            <div key={index} className="w-full grid place-items-start py-4 px-4 border border-transparent rounded shadow-sm text-sm font-medium font-semibold text-theme sections hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold">
                                                <div className='w-full flex justify-between items-center'>
                                                    <div className='flex justify-start items-center gap-2'>
                                                        {/* Icon or additional content can go here */}
                                                        {item.value}
                                                    </div>
                                                    <div className='flex justify-end items-center gap-1'>
                                                        {[1, 2, 3, 4, 5].map((rating) => (
                                                            <svg key={rating} onClick={() => handleChange(item.id, rating, 'rating')} className={`w-5 h-5 ${getRatingInfo('rating', item.id) >= rating ? 'text-yellow-300' : 'text-sections'} ms-1`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className="w-full mt-4 -mb-2">
                                                    <textarea
                                                        defaultValue={getRatingInfo('comment', item.id)}
                                                        onChange={(e) => handleChange(item.id, e.target.value, 'comment')}
                                                        id="comment"
                                                        name="comment"
                                                        rows="4"
                                                        className="block placeholder-sm text-sm p-2.5 w-full text-sm div-sections rounded-md border-none"
                                                        placeholder={t("Write your comment here…")}
                                                    ></textarea>
                                                    <p className="mt-2 text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('comment') && InputsErrors.comment}</span></p>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        ParametreContent && ParametreContent.map((item, index) => (
                                            <div key={index} className="w-full grid place-items-start py-4 px-4 border border-transparent rounded shadow-sm text-sm font-medium font-semibold text-theme sections hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold">
                                                <div className='w-full flex justify-between items-center'>
                                                    <div className='flex justify-start items-center gap-2'>
                                                        {/* Icon or additional content can go here */}
                                                        {item.name}
                                                    </div>
                                                    <div className='flex justify-end items-center gap-1'>
                                                        {[1, 2, 3, 4, 5].map((rating) => (
                                                            <svg key={rating} onClick={() => handleChange(item.id, rating, 'rating')} className={`w-5 h-5 ${getRatingInfo('rating', item.id) >= rating ? 'text-yellow-300' : 'text-sections'} ms-1`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className="w-full mt-4 -mb-2">
                                                    <textarea
                                                        defaultValue={getRatingInfo('comment', item.id)}
                                                        onChange={(e) => handleChange(item.id, e.target.value, 'comment')}
                                                        id="comment"
                                                        name="comment"
                                                        rows="4"
                                                        className="block placeholder-sm text-sm p-2.5 w-full text-sm div-sections rounded-md border-none"
                                                        placeholder="Write your comment here..."
                                                    ></textarea>
                                                    <p className="mt-2 text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('comment') && InputsErrors.comment}</span></p>
                                                </div>
                                            </div>
                                        ))
                                    )
                                }



                                <div>
                                    <button onClick={(e) => addReviewSelection(e)} disabled={isFetching} type="submit" className="w-full btn-edit  ">
                                        {isFetching ?
                                            (<svg class="w-4 h-4 text-gray-300 animate-spin" viewBox="0 0 64 64" fill="none"
                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                                <path
                                                    d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                                                    stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                <path
                                                    d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                                                    stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" class="text-gray-900">
                                                </path>
                                            </svg>)
                                            : (
                                                t('enregistrer')
                                            )
                                        }
                                    </button>
                                </div>
                            </form>


                            {/* {reviewParams &&
                                <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
                                    <div className="relative w-full max-h-screen findservice overflow-hidden -mt-10 rounded-xl  div-sections">
                                        <div className="absolute -top-2 -right-2 p-4">
                                            <a className='w-8 h-8' onClick={() => { setReviewParams(false) }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                                                </svg>
                                            </a>
                                        </div>
                                        <div className="w-full settingswidth ">
                                            <div className={`${LanguageSelected == 'ar' ? 'pl-6 ' : 'pr-6'}`} >
                                                <div className="flex  items-center justify-start ">
                                                    <p className="text-2xl text-gold px-3 py-2 font-bold">{t("Add review")}</p>
                                                </div>
                                            </div>
                                            <div>
                                                <div className='grid place-items-center w-full py-4 gap-4 px-4'>
                                                    <div className='flex justify-between w-full px-2 sections items-center h-14'>
                                                        <p className='text-sm text-theme font-semibold'>{singleRating.name}</p>

                                                        <div className="flex items-center">
                                                            <svg onClick={() => setSingleRating(prevState => ({ ...prevState, rating: 1 }))} className={`w-5 h-5 ${singleRating.rating >= 1 ? 'text-yellow-300' : 'text-sections'}  ms-1`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                            <svg onClick={() => setSingleRating(prevState => ({ ...prevState, rating: 2 }))} className={`w-5 h-5 ${singleRating.rating >= 2 ? 'text-yellow-300' : 'text-sections'}  ms-1`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                            <svg onClick={() => setSingleRating(prevState => ({ ...prevState, rating: 3 }))} className={`w-5 h-5 ${singleRating.rating >= 3 ? 'text-yellow-300' : 'text-sections'}  ms-1`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                            <svg onClick={() => setSingleRating(prevState => ({ ...prevState, rating: 4 }))} className={`w-5 h-5 ${singleRating.rating >= 4 ? 'text-yellow-300' : 'text-sections'}  ms-1`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                            <svg onClick={() => setSingleRating(prevState => ({ ...prevState, rating: 5 }))} className={`w-5 h-5 ${singleRating.rating >= 5 ? 'text-yellow-300' : 'text-sections'}  ms-1`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                        </div>


                                                    </div>
                                                    <div className=" w-full">
                                                        <textarea defaultValue={singleRating.comment} onChange={(e) => setSingleRating(prevState => ({ ...prevState, comment: e.target.value }))} type="text" id="comment"
                                                            name="comment"
                                                            className="appearance-none block placeholder-sm text-sm w-full px-3 py-2 bg-gray-700 border  rounded placeholder-gray-111 text-black  focus:outline-none active  " placeholder={t("comment")} required />
                                                        <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('comment') && InputsErrors.comment}</span></p>

                                                    </div>
                                                    <button onClick={(e) => handleConfirm(singleRating.id)} disabled={isFetching} type="submit" className={`w-full  btn-edit`}>
                                                        {isFetching ?
                                                            (<svg class="w-4 h-4 text-gray-300 animate-spin" viewBox="0 0 64 64" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                                                <path
                                                                    d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                                                                    stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                                <path
                                                                    d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                                                                    stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" class="text-gray-900">
                                                                </path>
                                                            </svg>)
                                                            : (
                                                                t('Confirm')
                                                            )
                                                        }

                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>} */}
                        </div>
                    </div>
                </div>


            }
        </div>
    )
}

export default ReviewSelection